import React from 'react';
import styled from 'styled-components';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/**
 * Common colors.
 * Generate a name from HEX color: http://chir.ag/projects/name-that-color
 * If the name already exists, try to be creative by adding a suffix :)
 */


var grayDarkM = '#41434A';
var primaryM = '#924B54';
var blue = '#4978BC';
var eastBayBlue = '#41538D';
var sanMarinoBlue = '#4C63AD';
var catskillWhite = '#E9ECF5';
var white = '#FFFFFF';
var altoGrey = '#D1D1D1';
var gray = '#8B8B8B';
/**
 * Breakpoints and media queries
 * Following this article #3
 * https://www.freecodecamp.org/news/the-100-correct-way-to-do-css-breakpoints-88d6a5ba1862/
 *
 * usage:
 * const StyledComponent = styled(Element)`
     [...]
     ${MQ_FOR_TABLET_PORTRAIT_UP} {
       [...]
     }
   `;
 */

var QUERY_FOR_PHONE_ONLY = "(max-width: 599px) and (orientation: portrait), (max-width: 900px) and (orientation: landscape)";
var MQ_FOR_PHONE_ONLY = "@media ".concat(QUERY_FOR_PHONE_ONLY);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;

var regular = 400;
var mediumBold = 500;
var semiBold = 600;
var bold = 700;
var primaryFont = "\"Graphik Web\", sans-serif";
var primaryFontM = "\"ProximaNova Web\", Arial, sans-serif";
var headingFontM = "\"GeorgiaPro Web\", Georgia, serif";
var Heading = styled.h3(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 25px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), primaryFont, regular);
Heading.displayName = 'Heading';
var PageHeader = styled.h3(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: black;\n  font-family: ", ";\n  font-size: 32px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n\n  ", " {\n    font-size: 24px;\n    line-height: 24px;\n  }\n"])), primaryFont, semiBold, MQ_FOR_PHONE_ONLY);
PageHeader.displayName = 'PageHeader';
var H1 = styled.h1(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 50px;\n  font-weight: ", ";\n  line-height: 56px;\n  margin: 0;\n"])), primaryFont, bold);
H1.displayName = 'H1';
var H1M = styled.h1(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 27px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), grayDarkM, headingFontM, semiBold);
H1M.displayName = 'H1M';
var H2 = styled.h2(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 30px;\n  font-weight: ", ";\n  line-height: 40px;\n  margin: 0;\n"])), primaryFont, regular);
H2.displayName = 'H2';
var H3 = styled.h3(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 25px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), primaryFont, regular);
H3.displayName = 'H3';
var H4 = styled.h4(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 20px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), primaryFont, regular);
H4.displayName = 'H4';
var H5 = styled.h5(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 20px;\n  margin: 0;\n"])), primaryFont, semiBold);
H5.displayName = 'H5';
var H6 = styled.h6(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n  line-height: 20px;\n  margin: 0;\n  text-transform: uppercase;\n"])), primaryFont, semiBold);
H6.displayName = 'H6';
var H7 = styled.h6(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 24px;\n  margin: 0;\n"])), primaryFont, regular);
H7.displayName = 'H7';
var H8 = styled.h6(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  line-height: 20px;\n  margin: 0;\n"])), primaryFont, regular);
H8.displayName = 'H8';
var H9 = styled.h6(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n  line-height: 24px;\n  margin: 0;\n  text-transform: uppercase;\n"])), primaryFont, mediumBold);
H9.displayName = 'H9';
var H10 = styled.h6(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: ", ";\n  line-height: 12px;\n  margin: 0;\n"])), primaryFont, regular);
H9.displayName = 'H9';
var Text = styled.p(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 125%;\n  margin: 0;\n"])), primaryFont, regular);
var TextM = styled.p(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 125%;\n  margin: 0;\n"])), grayDarkM, primaryFontM, regular);
var Link = styled.a(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  text-decoration: none;\n"])), blue, primaryFont, mediumBold);
var LinkM = styled.a(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  text-decoration: none;\n"])), primaryM, primaryFontM, regular);

var _templateObject$1;

var _excluded = ["children"];
var PRIMARY_BUTTON_PADDING = '0.55em';
/**
 * Primary CTA. This has a blue background
 * and white text.
 */

var PrimaryCta = function PrimaryCta(props) {
  return (
    /*#__PURE__*/
    React.createElement(ButtonInternal, _extends({
      priority: "primary"
    }, props))
  );
};

PrimaryCta.displayName = 'PrimaryCta';
/**
 * Secondary CTA. This has a white background
 * and blue text.
 */

var SecondaryCta = function SecondaryCta(props) {
  return (
    /*#__PURE__*/
    React.createElement(ButtonInternal, _extends({
      priority: "secondary"
    }, props))
  );
};

SecondaryCta.displayName = 'SecondaryCta';
/**
 * TertiaryCta CTA. This has a transparent background
 * and blue text.
 */

var TertiaryCta = function TertiaryCta(props) {
  return (
    /*#__PURE__*/
    React.createElement(ButtonInternal, _extends({
      priority: "tertiary"
    }, props))
  );
};

TertiaryCta.displayName = 'TertiaryCta';
/**
 * Internal button structure for primary and secondary CTAs.
 */

var ButtonInternal = function ButtonInternal(_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement(BaseButton, _extends({}, other, {
      disabledStyle: other.disabled
    }),
    /*#__PURE__*/
    React.createElement("span", null,
    /*#__PURE__*/
    React.createElement("div", {
      className: "text"
    }, children)))
  );
};
/**
 * Styles.
 */


var BaseButton = styled.button(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  position: relative;\n  text-align: center;\n  font-family: ", ";\n  color: ", ";\n  line-height: ", "px;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  width: 100%;\n  box-sizing: border-box;\n  vertical-align: middle;\n  appearance: none;\n  text-decoration: none;\n\n  ", "\n\n  max-width: ", "px;\n  cursor: pointer;\n  border-radius: 0;\n  ", "\n  margin-right: ", ";\n  margin-left: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  background-color: ", ";\n  transition: color 0.1s cubic-bezier(0.16, 0.08, 0.355, 1),\n    background 0.1s cubic-bezier(0.16, 0.08, 0.355, 1);\n  display: inline-block;\n  outline: none;\n\n  &:active,\n  &:focus {\n    outline: 0;\n  }\n\n  & .text {\n    height: 32px;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  @media (hover: hover) {\n    &:hover:not(:disabled) {\n      ", "\n    }\n  }\n\n  & {\n    position: relative;\n    transition: background-color 300ms ease-out;\n  }\n\n  & span {\n    display: inline-block;\n    position: relative;\n    transition: all 300ms ease-out;\n    will-change: transform;\n    vertical-align: middle;\n    height: 33px;\n    transform: none;\n  }\n\n  & svg {\n    position: absolute;\n    width: 1.1em;\n    right: 0px;\n    right: 0rem;\n    opacity: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: all 300ms ease-out;\n    will-change: right, opacity;\n    strokewidth: 5;\n    stroke-color: transparent;\n  }\n"])), primaryFont, function (props) {
  return props.priority === 'primary' ? white : props.priority === 'secondary' ? eastBayBlue : blue;
}, function (props) {
  return props.miniButton ? 16 : 32;
}, PRIMARY_BUTTON_PADDING, PRIMARY_BUTTON_PADDING, function (props) {
  return props.miniButton && "\n    max-height: 30px;\n  ";
}, function (props) {
  return props.miniButton ? 112 : 709;
}, function (props) {
  return props.priority === 'tertiary' ? "\n    border: none;\n  " : "\n    border: 1px ".concat(eastBayBlue, " solid;\n  ");
}, function (p) {
  return p.mr || '0';
}, function (p) {
  return p.ml || '0';
}, function (p) {
  return p.mt || '0';
}, function (p) {
  return p.mb || '0';
}, function (props) {
  return props.priority === 'primary' ? eastBayBlue : props.priority === 'secondary' ? white : 'transparent';
}, function (props) {
  return props.disabledStyle && props.priority === 'primary' && "\n    background-color: ".concat(altoGrey, ";\n    border-color: ").concat(altoGrey, ";\n  ");
}, function (props) {
  return props.disabledStyle && props.priority === 'secondary' && "\n    border-color: ".concat(altoGrey, ";\n    color: ").concat(gray, ";\n  ");
}, function (props) {
  return props.disabledStyle && props.priority === 'tertiary' && "\n    color: ".concat(gray, ";\n  ");
}, function (props) {
  return props.priority === 'primary' ? "\n                background-color: ".concat(sanMarinoBlue, ";\n                border-color: ").concat(sanMarinoBlue, ";\n              ") : props.priority === 'secondary' ? "\n                background-color: ".concat(catskillWhite, ";\n                border-color: ").concat(blue, ";\n              ") : "\n            // tertiary\n            border: 1px solid ".concat(blue, ";\n          ");
});
BaseButton.displayName = 'BaseButton';
export { PrimaryCta, SecondaryCta, TertiaryCta };